import React from 'react';

const skillsData = [
  {
    category: 'Testing Methodologies',
    skills: [
      'Manual Testing', 'Automated Testing', 'Functional Testing', 'Integration Testing',
      'Regression Testing', 'Smoke Testing', 'Sanity Testing', 'Exploratory Testing', 'User Acceptance Testing'
    ]
  },
  {
    category: 'Tools & Technologies',
    skills: [
      'JIRA', 'CRM Platforms', 'Bug Tracking Systems', 'Test Management Tools'
    ]
  },
  {
    category: 'Test Automation',
    skills: [
      'Cypress', 'JavaScript'
    ]
  },
  {
    category: 'DevOps & CI/CD',
    skills: [
      'DevOps', 'Continuous Integration', 'Continuous Delivery', 'CI/CD Pipelines', 'Automation'
    ]
  },
  {
    category: 'Agile & Project Management',
    skills: [
      'Agile Project Management', 'Lean Processes', 'Agile Methodologies', 'Project Management', 'Jira Cloud'
    ]
  },
  {
    category: 'AI & Emerging Technologies',
    skills: [
      'Generative AI', 'Large Language Models', 'LLM', 'Prompt Engineering', 'AI Communication', 'AI Testing'
    ]
  },
  {
    category: 'Technical Proficiencies',
    skills: [
      'Test Case Development', 'Test Plan Creation', 'Defect Management', 'Cross-Browser Testing'
    ]
  }
];

const Skills = ({ hideTitle = false }) => (
  <section id="skills" className="section-padding bg-white dark:bg-dark-100 transition-colors duration-300">
    <div className="container-custom">
      {!hideTitle && (
      <h2 className="text-3xl font-bold mb-8 text-secondary-800 dark:text-white text-center">Technical Skills</h2>
      )}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {skillsData.map((section) => (
          <div
            key={section.category}
            className="bg-white/80 dark:bg-dark-200/80 border border-primary-200 dark:border-primary-600 rounded-2xl shadow-lg p-6 flex flex-col items-center text-center backdrop-blur-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
          >
            <h3 className="text-lg font-semibold mb-4 text-primary-700 dark:text-white">{section.category}</h3>
            <div className="flex flex-wrap gap-2 justify-center">
              {section.skills.map((skill) => (
                <span
                  key={skill}
                  className="px-3 py-1 rounded-full bg-primary-100 dark:bg-primary-700 text-primary-700 dark:text-primary-200 text-sm font-medium shadow-sm border border-primary-200 dark:border-primary-400"
                >
                  {skill}
                </span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Skills; 